import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import MapMarker from "../../components/MapMarker/MapMarker";
import SimpleMapMarker from "../../components/SimpleMapMarker/SimpleMapMarker";
// Google Maps api for react
import { Polyline } from "@react-google-maps/api";

// Info marker configuration
import { configService, configNote } from "views/Map/MapPageConfig";

// helpers
import { iconType, iconNoteType, iconServiceType } from "helpers/getIcon";

// Hooks
import { useClock } from "hooks/useClock";

// variables
import * as variables from "components/MapLateralMenu/variable";
import { ACTIVE, CANCELED } from "views/Map/MapPageTypes";

// actions creators
import { setRowChecked } from "redux/ducks/mapPage";

// actions creators
import { REMOVE_SELECTED_UNIT, SET_SELECTED_UNITS } from "redux/ducks/mapPage";
import { configUnitTitle } from "views/Map/MapPageConfig";

const SelectedUnitMarkers = ({ unit, isLoading, color }) => {
  const dispatch = useDispatch();
  const addSelectedUnit = useCallback(
    (id) => dispatch({ type: SET_SELECTED_UNITS, payload: id }),
    [dispatch]
  );
  const removeSelectedUnit = useCallback(
    (id) => dispatch({ type: REMOVE_SELECTED_UNIT, payload: id }),
    [dispatch]
  );
  const clock = useClock(60000);
  const selectedUnits = useSelector(
    (state) => state.map.selectedUnits,
    shallowEqual
  );
  const checked = useSelector((state) => state.map.checked, shallowEqual);

  const filterOrders = (item, checked) => {
    if (item) {
      if (
        checked.includes(variables.PENDING) &&
        checked.includes(variables.CANCEL)
      ) {
        return item.servicesList;
      }
      if (
        checked.includes(variables.PENDING) &&
        !checked.includes(variables.CANCEL)
      ) {
        return item.servicesList.filter((order) => order.status === ACTIVE);
      }
      if (
        !checked.includes(variables.PENDING) &&
        checked.includes(variables.CANCEL)
      ) {
        return item.servicesList.filter((order) => order.status === CANCELED);
      }
    }
    return [];
  };
  const filterNotes = (item, checked) => {
    if (item) {
      if (
        checked.includes(variables.ORDERS) &&
        checked.includes(variables.ONTRANSIT)
      ) {
        return item.notesList;
      }
      if (
        checked.includes(variables.ORDERS) &&
        !checked.includes(variables.ONTRANSIT)
      ) {
        return item.notesList.filter((note) => (note.account ? true : false));
      }
      if (
        !checked.includes(variables.ORDERS) &&
        checked.includes(variables.ONTRANSIT)
      ) {
        return item.notesList.filter((note) => (!note.account ? true : false));
      }
    }
    return [];
  };

  // effects
  useEffect(() => {
    const initalChecked = [
      variables.ONTRANSIT,
      variables.CANCEL,
      variables.ORDERS,
      variables.PENDING,
    ];
    dispatch(setRowChecked(initalChecked));
  }, []);

  const isOpen = (number) => {
    return selectedUnits.includes(number);
  };
  const symbolOne = {
    path: "M0,0 L2,5 l-4,0, Z",
    strokeColor: color,
    fillColor: color,
    fillOpacity: 1,
  };

  const options = {
    strokeColor: color,
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: color,
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 30000,
    icons: [
      {
        icon: symbolOne,
        offset: "0",
        repeat: "100px",
      },
    ],

    zIndex: 1,
  };

  const filteredNotes = filterNotes(unit, checked);
  const filteredOrders = filterOrders(unit, checked);

  return (
    <React.Fragment>
      <Polyline path={unit.route} options={options} />
      <SimpleMapMarker
        item={unit}
        isOpen={isOpen(unit["number"])}
        onSelect={
          !selectedUnits.includes(unit.number)
            ? addSelectedUnit
            : removeSelectedUnit
        }
        idMarker="number"
        lat={unit.location.lat}
        lng={unit.location.lon}
        onCloseInfo={removeSelectedUnit}
        config={configUnitTitle}
        icon={`${iconType(unit.type, unit.last_login)}`}
      />

      {filteredNotes.length > 0 &&
        !isLoading &&
        filteredNotes.map((item, index) => {
          return (
            <MapMarker
              key={`${item.folio}${item.account}-${index}`}
              item={item}
              isOpen={isOpen(item["folio"])}
              onSelect={
                !selectedUnits.includes(item.folio)
                  ? addSelectedUnit
                  : removeSelectedUnit
              }
              idMarker="folio"
              lat={item.location.lat}
              lng={item.location.lon}
              config={configNote}
              color={color}
              icon={`${iconServiceType(item.account)}`}
              onCloseInfo={removeSelectedUnit}
            />
          );
        })}

      {filteredOrders.length > 0 &&
        !isLoading &&
        filteredOrders.map((item, index) => {
          return (
            <MapMarker
              key={`${item.folio}i${index}`}
              item={item}
              isOpen={isOpen(item["folio"])}
              onSelect={
                !selectedUnits.includes(item.folio)
                  ? addSelectedUnit
                  : removeSelectedUnit
              }
              idMarker="folio"
              lat={item.location.lat}
              lng={item.location.lon}
              config={configService}
              color={color}
              clock={clock}
              onCloseInfo={removeSelectedUnit}
              icon={`${iconNoteType(unit.type, item.status)}`}
            />
          );
        })}
    </React.Fragment>
  );
};

export default React.memo(SelectedUnitMarkers);
